import { useState, createContext, useMemo, useCallback } from "react";
import { SignupUser, SignUpStepType } from "../../types/ClientSpace";

interface SignUpContextFormType {
    step: number;
    signupUser: SignupUser;
    useDiffrentBillingAddress: boolean;
}

export const SignUpContext = createContext<SignUpStepType>({
    step: 1,
    useDiffrentBillingAddress: false,
    signupUser: {
        name: "",
        email: "",
        phoneNumber: "",
        password: "",
        establishment: {
            siret: "",
            establishmentType: "",
            // synerpaNum: "",
            companyName: "",
            contactAddress: {
                postalCode: "",
                city: "",
                street: "",
                additionalDetails: "",
            },
            billingAddress: {
                postalCode: "",
                city: "",
                street: "",
                additionalDetails: "",
            },
            establishmentGroup: "",
            contacts: [],
        },
    },
    updateSignupForm: (signupForm: any) => null,
});

export const SignUpContextProvider = ({ children }: any) => {
    const [signupForm, setSignupForm] = useState<SignUpContextFormType>({
        step: 1,
        useDiffrentBillingAddress: false,
        signupUser: {
            name: "",
            email: "",
            phoneNumber: "",
            password: "",
            establishment: {
                siret: "",
                establishmentType: "",
                // synerpaNum: "",
                companyName: "",
                contactAddress: {
                    postalCode: "",
                    city: "",
                    street: "",
                    additionalDetails: "",
                },
                billingAddress: {
                    postalCode: "",
                    city: "",
                    street: "",
                    additionalDetails: "",
                },
                establishmentGroup: "",
                contacts: [],
            },
        },
    });

    const updateSignupForm = useCallback((clientForm: any) => {
        setSignupForm(clientForm);
    }, []);

    const signupWrapperContext = useMemo(
        () => ({
            ...signupForm,
            updateSignupForm,
        }),
        [signupForm, updateSignupForm]
    );

    return (
        <SignUpContext.Provider value={signupWrapperContext}>
            {children}
        </SignUpContext.Provider>
    );
};
